"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pressable = void 0;
const react_native_1 = require("react-native");
exports.Pressable = react_native_1.Pressable;
//# sourceMappingURL=Pressable.js.map